import { render, staticRenderFns } from "./HistoricoAtividades.vue?vue&type=template&id=0cc4e1e5"
import script from "./HistoricoAtividades.vue?vue&type=script&lang=js"
export * from "./HistoricoAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports